import type { RegisterFormFields } from './Context'
import type { FormikHelpers } from 'formik/dist/types'
import { useFetch, useRecaptcha, useToast } from '@ztechapps/common.hook'
import { useRegisterContext } from './Context'

type UseSubmitRegisterResult = (
  args: RegisterFormFields,
  formikBag: Pick<FormikHelpers<RegisterFormFields>, 'setSubmitting'>
) => Promise<void>

export const useSubmitRegister = (): UseSubmitRegisterResult => {
  const { url, onSuccess, recaptchaSiteKey, setErrorMessage } = useRegisterContext()

  const { getTokenOrThrow } = useRecaptcha({ recaptchaSiteKey })

  const [onRegister] = useFetch(url)

  const { showSuccess } = useToast()

  return async (args, formikBag) => {
    const { setSubmitting } = formikBag

    try {
      setSubmitting(true)

      const recaptchaToken = await getTokenOrThrow()

      setErrorMessage('')

      const { username, fullName, password, phone } = args

      const { error } = await onRegister({ username, name: fullName, password, phone, recaptchaToken })

      if (error) throw error

      await onSuccess?.({ values: args, getRecaptchaToken: getTokenOrThrow })

      showSuccess({ message: 'You have successfully registered' })
    } catch (e) {
      setErrorMessage(e?.message ?? e)
    } finally {
      setSubmitting(false)
    }
  }
}
